import { render, staticRenderFns } from "./DialogStatiMercati.vue?vue&type=template&id=7e801bd4&scoped=true&"
import script from "./DialogStatiMercati.vue?vue&type=script&lang=js&"
export * from "./DialogStatiMercati.vue?vue&type=script&lang=js&"
import style0 from "./DialogStatiMercati.vue?vue&type=style&index=0&id=7e801bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e801bd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e801bd4')) {
      api.createRecord('7e801bd4', component.options)
    } else {
      api.reload('7e801bd4', component.options)
    }
    module.hot.accept("./DialogStatiMercati.vue?vue&type=template&id=7e801bd4&scoped=true&", function () {
      api.rerender('7e801bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogStatiMercati.vue"
export default component.exports